module.exports = __webpack_public_path__ + "img/pdf.44bdda80.png";